import { render, staticRenderFns } from "./BlueButton.vue?vue&type=template&id=7159a824"
import script from "./BlueButton.vue?vue&type=script&lang=ts"
export * from "./BlueButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports